/**
 * TraVoS最新/過去種別
 */
export enum RADIO_TRAVOS_LIST {
  history = 1,
  realTime = 2,
}

/**
 * TraVoS過去データ種別
 */
export enum RADIO_TRAVOS_HISTORY_LIST {
  measured1Hour = 1,
}

/**
 * TraVos最新データラジオボタン項目
 */
export enum RADIO_TRAVOS_REALTIME_LIST {
  value5Minutes = 1,
  value1Hour = 2,
}

/**
 * 一般交通量調査テーブル種別
 */
export enum RADIO_GENERAL_TRAFFIC_TABLE_TYPE_LIST {
  location = 1,
  time = 2,
}

/**
 * 一般交通量調査データデータ種別
 */
export enum GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST {
  // 道路種別
  roadCategory = "1",
  // 車線数
  laneCount = "2",
  // 昼間12時間交通量（全車・上下計）
  day12hVolume = "3",
  // 24時間交通量（全車・上下計）
  day24hVolume = "4",
  // 混雑度
  congestionLevel = "5",
  // 朝夕旅行速度
  morningEveningSpeed = "6",
  // 昼間旅行速度
  daytimeSpeed = "7",
}

/**
 * 一般交通量調査データ道路種別
 */
export const GENERAL_TRAFFIC_ROAD_CATEGORY_LIST = [
  {
    text: "一般都道府県道･指定市の一般市道",
    key: "generalPrefectures",
    value: "1",
  },
  {
    text: "主要地方道（都道府県道･指定市道）",
    key: "mainLocalRoad",
    value: "2",
  },
  {
    text: "一般国道（直轄）",
    key: "generalHighwayDirectControl",
    value: "3",
  },
  {
    text: "一般国道（その他）",
    key: "generalHighwayOthers",
    value: "4",
  },
  {
    text: "都市高速道路",
    key: "urbanHighway",
    value: "5",
  },
  {
    text: "高速自動車国道",
    key: "expressNationalHighway",
    value: "6",
  },
];

/**
 * ETC確定値データ種別
 */
export enum RADIO_ETC_DATA_TYPE_LIST {
  drmLink = 1,
  basicSection = 2,
}

/**
 * ETC確定値時間種別
 */
export enum RADIO_ETC_TIME_TYPE_LIST {
  day15Minutes = 1,
  day1Hour = 2,
  month1Hour = 3,
}

/**
 * ETC確定値休平日区分ラジオボタン項目
 */
export enum RADIO_ETC_DAY_TYPE_LIST {
  weekday = 1,
  holiday = 2,
  allday = 3,
}

/**
 * ODデータ種別ラジオボタン項目
 */
export enum OD_DATA_TYPE_LIST {
  //都道府県
  prefectures = 3,
}
/**
 * ODデータ種別ラジオボタン
 */
export const RADIO_OD_DATA_TYPE_LIST = [
  { text: "都道府県", value: OD_DATA_TYPE_LIST.prefectures },
];

/**
 * OD車種
 */
export enum OD_CAR_TYPE_LIST {
  // 乗用車
  passengerCar = 1,
  // 小型貨物車
  smallCargo = 2,
  // 普通貨物車
  normalCargo = 3,
  // 車種計
  total = 4,
}
/**
 * OD車種ラジオボタン
 */
export const RADIO_OD_CAR_TYPE_LIST = [
  {
    text: "乗用車",
    value: OD_CAR_TYPE_LIST.passengerCar,
  },
  {
    text: "小型貨物車",
    value: OD_CAR_TYPE_LIST.smallCargo,
  },
  {
    text: "普通貨物車",
    value: OD_CAR_TYPE_LIST.normalCargo,
  },
  {
    text: "車種計",
    value: OD_CAR_TYPE_LIST.total,
  },
];

/**
 * OD年度
 */
export enum OD_YEAR_LIST {
  reiwa3 = 1,
}
/**
 * OD年度ラジオボタン
 */
export const RADIO_OD_YEAR_LIST = [
  { text: "令和3年度調査", value: OD_YEAR_LIST.reiwa3 },
];

/**
 * OD発生・集中交通量移動目的
 */
export enum OD_GENERATION_PURPOSE_LIST {
  // 通勤・通学
  commuting = "01",
  // 業務
  work = "02",
  // 私事
  personal = "03",
  // 帰社・帰宅
  returnOfficeHome = "04",
  // 営業
  sales = "05",
  // その他
  other = "06",
  // 分類外
  unclassified = "08",
  // 不明
  unknown = "09",
  // 目的計
  purposeTotal = "10",
}
/**
 * OD発生・集中交通量移動目的ラジオボタン
 */
export const RADIO_OD_GENERATION_PURPOSE_LIST = [
  {
    text: "通勤・通学",
    value: OD_GENERATION_PURPOSE_LIST.commuting,
  },
  {
    text: "業務",
    value: OD_GENERATION_PURPOSE_LIST.work,
  },
  {
    text: "私事",
    value: OD_GENERATION_PURPOSE_LIST.personal,
  },
  {
    text: "帰社・帰宅",
    value: OD_GENERATION_PURPOSE_LIST.returnOfficeHome,
  },
  {
    text: "営業",
    value: OD_GENERATION_PURPOSE_LIST.sales,
  },
  {
    text: "その他",
    value: OD_GENERATION_PURPOSE_LIST.other,
  },
  {
    text: "分類外",
    value: OD_GENERATION_PURPOSE_LIST.unclassified,
  },
  {
    text: "不明",
    key: "unknown",
    value: OD_GENERATION_PURPOSE_LIST.unknown,
  },
  {
    text: "目的計",
    value: OD_GENERATION_PURPOSE_LIST.purposeTotal,
  },
];

/**
 * OD発生・集中交通量表示対象
 */
export enum OD_TARGET_LIST {
  //発生量
  generated = 1,
  //集中量
  concentration = 2,
  //発生集中量
  generationConcentrated = 3,
}
/**
 * OD発生・集中交通量表示対象ラジオボタン
 */
export const RADIO_OD_TARGET_LIST = [
  {
    text: "発生量",
    value: OD_TARGET_LIST.generated,
  },
  {
    text: "集中量",
    value: OD_TARGET_LIST.concentration,
  },
  {
    text: "発生集中量",
    value: OD_TARGET_LIST.generationConcentrated,
  },
];

/**
 * DRM道路区分ラジオボタン項目
 */
export enum RADIO_DRM_ROAD_TYPE_LIST {
  basicRoad = 1,
  allRoad = 2,
}

/**
 * データ存在期間集合型
 */
export type dateRanges = {
  travosHistoryMeasured1HourQ82?: dateRange;
  travosHistoryMeasured1HourQa82?: dateRange;
  etcDrmLinkDay15Minutes?: dateRange;
  etcDrmLinkDay1Hour?: dateRange;
  etcDrmLinkMonth1Hour?: dateRange;
  etcBasicSectionDay15Minutes?: dateRange;
  etcBasicSectionDay1Hour?: dateRange;
  etcBasicSectionMonth1Hour?: dateRange;
};

/**
 * データ存在期間型
 */
export type dateRange = {
  mindate?: Date;
  maxdate?: Date;
};

/**
 * 日時コントローラ日時
 */
export interface IControlerDate {
  year: string;
  month: string;
  day: string;
  hour: number;
  minute: number;
}

/**
 * 5分値データ更新バッファ（分）
 */
export const UPDATE_BUFFER_5MINUTES = 25;

/**
 * 1時間値データ更新バッファ（分）
 */
export const UPDATE_BUFFER_1HOUR = 85;
